import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/samrod/Sites/caroadhouse/packages/web/src/app/events/EventsClient.tsx");
